<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row">
      <!-- RADIAL CHART -->
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <generic-card-line
          v-if="opexOverview2"
          type="radialBar"
          :analyticsData="opexOverview2.analyticsData"
          title="Goal Overview"
          :chartData="opexOverview2.chartData"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <generic-card-line
          v-if="subscribersOverview"
          type="statistics"
          :analyticsData="subscribersOverview.analyticsData"
          title="Subscribers Gained"
          :chartData="subscribersOverview.chartData"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <generic-card-line
          v-if="sessionsData2"
          type="basicDonut"
          :analyticsData="sessionsData2.analyticsData"
          title="DONUT"
          :chartData="sessionsData2.chartData"
        />
      </div>
    </div>
    <div class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full md:w-2/3 mb-base">
         <generic-card-line
          v-if="revenueComparisonLine2"
          type="statistics"
          :analyticsData="revenueComparisonLine2.analyticsData"
          title="Revenue"
          :chartData="revenueComparisonLine2.chartData"
        />
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
       <generic-card-line
          v-if="profitOverview2"
          type="basicColumn"
          :analyticsData="profitOverview2.analyticsData"
          title="Profit"
          :chartData="profitOverview2.chartData"
        />
      </div>
    </div>
    <div class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full md:w-2/3 mb-base">
         <!-- <generic-card-line
          v-if="revenueComparisonLine2"
          type="statistics"
          :analyticsData="revenueComparisonLine2.analyticsData"
          title="Revenue"
          :chartData="revenueComparisonLine2.chartData" 
        /> -->
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
       <generic-card-line
          v-if="carsData2"
          type="table"
          :analyticsData="carsData2.analyticsData"
          title="Cars Data"
          :chartData="carsData2.chartData"
        />
      </div>
    </div>
    <div class="vx-row">
      <!-- RADIAL CHART -->
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <radial-bar-card-line
          v-if="opexOverview && opexOverview.analyticsData"
          leftDataTitle="Actual"
          rightDataTitle="Budget"
          :leftDataValue="opexOverview.analyticsData.actual | k_formatter"
          :rightDataValue="opexOverview.analyticsData.budget | k_formatter"
          title="Goal Overview 64d"
          :chartData="opexOverview.series"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          v-if="subscribersGained && subscribersGained.analyticsData"
          icon="UsersIcon"
          :statistic="subscribersGained.analyticsData.subscribers | k_formatter"
          statisticTitle="Subscribers Gained"
          :chartData="subscribersGained.series"
          type="area"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <donut-chart-card
          v-if="sessionsData && sessionsData.analyticsData"
          title="Donut"
          :labels="sessionsData.labels"
          :comparisonData="sessionsData.analyticsData"
          :chartData="sessionsData.series"
        />
      </div>
    </div>
    <div class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full md:w-2/3 mb-base">
        <comparaison-line-card-line
          v-if="revenueComparisonLine && revenueComparisonLine.analyticsData"
          leftDataTitle="This Month"
          rightDataTitle="Last Month"
          :leftDataValue="revenueComparisonLine.analyticsData.thisMonth"
          :rightDataValue="revenueComparisonLine.analyticsData.lastMonth"
          title="Revenue"
          :chartData="revenueComparisonLine.series" />
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
        <column-chart-card
          v-if="profitOverview"
          title="Profit"
          :chartData="profitOverview.series" />
      </div>
    </div>
    <div class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full md:w-2/3 mb-base">
        <comparaison-bar-card 
          v-if="revenueComparisonLine && revenueComparisonLine.analyticsData"
          leftDataTitle="This Month"
          rightDataTitle="Last Month"
          :leftDataValue="revenueComparisonLine.analyticsData.thisMonth"
          :rightDataValue="revenueComparisonLine.analyticsData.lastMonth"
          title="Revenue"
          :chartData="revenueComparisonLine.series" />
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
        <table-card
          v-if="carsData && carsData.analyticsData"
          title="Revenue"
          :tableData="carsData.analyticsData"
          :columnDefs="carsData.columnDefs" />
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import RadialBarCardLine from "@/components/statistics-cards/RadialBarCardLine.vue";
import ComparaisonLineCardLine from "@/components/statistics-cards/ComparaisonLineCardLine.vue";
import ComparaisonBarCard from "@/components/statistics-cards/ComparaisonBarCard.vue";
import GenericCardLine from "@/components/statistics-cards/GenericCardLine.vue";
import ColumnChartCard  from '@/components/statistics-cards/ColumnChartCard.vue';
import DonutChartCard  from '@/components/statistics-cards/DonutChartCard.vue';
import TableCard from '@/components/statistics-cards/TableCard.vue';
import analyticsData from './analyticsData.js'

export default {
  components: {
    StatisticsCardLine,
    RadialBarCardLine,
    GenericCardLine,
    ComparaisonLineCardLine,
    ComparaisonBarCard,
    ColumnChartCard,
    DonutChartCard,
    TableCard
  },
  data() {
    return {
      subscribersGained: {},
      opexOverview: {},
      opexOverview2: {},
      profitOverview: {},
      profitOverview2: {},
      revenueComparisonLine2: {},
      carsData: {},
      carsData2 : {},
      subscribersOverview: {},
      revenueComparisonLine: {},
      opexOverviewAnalyticsData: {},
      analyticsData,
      sessionsData: {},
      sessionsData2: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  created() {

    // Subscribers gained - Statistics
    this.$http
      .get("/api/card/card-analytics/session-by-device")
      .then((response) => {
        this.sessionsData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });


    this.$http
      .get("/api/card/card-analytics/session-by-device2")
      .then((response) => {
        this.sessionsData2 = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Subscribers gained - Statistics
    this.$http
      .get("/api/card/card-statistics/subscribers")
      .then((response) => {
        this.subscribersGained = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Goal Overview
    this.$http
      .get("/api/card/card-analytics/opex-overview")
      .then((response) => {
        this.opexOverview = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$http
      .get("/api/card/card-statistics/subscribers3")
      .then((response) => {
        this.subscribersOverview = response.data;
        this.subscribersOverview = {
          analyticsData: response.data.analyticsData,
          chartData: {
            icon: "UsersIcon"
          }
        };
      })
      .catch((error) => {
        console.log(error);
      });

    // Goal Overview
    this.$http
      .get("/api/card/card-analytics/opex-overview3")
      .then((response) => {
        this.opexOverview2 = {
          analyticsData: response.data.analyticsData,
          chartData: {
            leftDataTitle: "Actual",
            rightDataTitle: "Budget",
            dataFilter: "k_formatter"
          }
        };
      })
      .catch((error) => {
        console.log(error);
      });

    this.$http
      .get("/api/card/card-analytics/profit-statistics")
      .then((response) => {
        this.profitOverview = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$http.get("/api/card/card-analytics/profit-statistics2")
      .then((response) => {
        this.profitOverview2 = {
          analyticsData: response.data.analyticsData,
          chartData: {
            categories : ["element 1111"],
            yAxisTitle: "patate"
          }
        };
      })
      .catch((error) => {
        console.log(error);
      });

    // Revenue Comparison
    this.$http.get('/api/card/card-analytics/revenue-comparison')
      .then((response) => { this.revenueComparisonLine = response.data })
      .catch((error) => { console.log(error) })

    this.$http.get('/api/card/card-analytics/revenue-comparison2')
      .then((response) => {
        this.revenueComparisonLine2 = {
          analyticsData: response.data.analyticsData,
          chartData: {
            leftDataTitle: "This Month",
            rightDataTitle: "Last Month"
          }
        };
      })
      .catch((error) => {
        console.log(error);
      });

    this.$http.get('/api/card/card-analytics/cars')
      .then((response) => {
        this.carsData = {
          analyticsData: response.data,
          columnDefs: [
            { field: 'make' },
            { field: 'model' },
            { field: 'price' }
          ]
        };
      })
      .catch((error) => {
        console.log(error);
      });
    
    this.$http.get('/api/card/card-analytics/cars')
      .then((response) => {
        this.carsData2 = {
          analyticsData: response.data,
          chartData: {
            columnDefs: [
              { field: 'make' },
              { field: 'model' },
              { field: 'price' }
            ]
          }
        };
      })
      .catch((error) => {
        console.log(error);
      });
    
  },
  
  methods: {
    drillTo() {
      this.$router.push({ name: 'abc-kpi', query: { kpiId: 1} });
    }
  }
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
